import InputBase from '@mui/material/InputBase';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchInputWrapper from './SearchInputWrapper';
import { isHex64, isNumericString, isOmnistarAddress, isUUIDv4 } from '../utils/utils';

function hasValidChars(str: string): boolean {
    const regex = /^[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)*$/; // regular expression to match only alphanumeric characters and hyphens
    return regex.test(str);
}

export default function GeneralInput() {
    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (inputValue.length < 2 || !hasValidChars(inputValue)){
            setError("Invalid search value")
            return;
        }
        
        let to: string = "/"
        if(isHex64(inputValue)) to = `/tx/${inputValue}`;
        else if(isUUIDv4(inputValue)) to = `/dex/${inputValue}`;
        else if(isNumericString(inputValue)) to = `/block/${inputValue}`;
        else if(isOmnistarAddress(inputValue)) to = `/snapshots/${inputValue}`;
        else to = `/address-error/${inputValue}`;
        
        setInputValue('');
        navigate(to);   
    };

    return (
            <>
                <SearchInputWrapper handleSubmit={handleSubmit} >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        error={!!error}
                        
                        placeholder="Search for addresses, transactions, blocks and accounts"
                        inputProps={{ 'aria-label': 'Search for safes, transactions, blocks and accounts' }}
                        fullWidth={true}
                        onChange={(e) => setInputValue(e.target.value)}
                        onSubmit={handleSubmit}
                        value={inputValue}
                        />
                </SearchInputWrapper>
                {!!error? <span style={{color: "red"}}>{error}</span>: null}
            </>
    );
}